
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/discover/profile/[username]",
      function () {
        return require("private-next-pages/discover/profile/[username].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/discover/profile/[username]"])
      });
    }
  